import {
  DOMParser as PmDOMParser,
  DOMSerializer,
  Node as PmNode,
} from 'prosemirror-model'
import { EditorView } from 'prosemirror-view'
import editorSchema from './schema'

export function parseHtmlToDoc(html: string) {
  const container = document.createElement('div')
  container.innerHTML = html
  return PmDOMParser.fromSchema(editorSchema).parse(container)
}

const cachedSerializer = DOMSerializer.fromSchema(editorSchema)

export function getDocHtml(view: EditorView): string {
  const div = document.createElement('div')
  const fragment = cachedSerializer.serializeFragment(view.state.doc.content)
  div.appendChild(fragment)
  return div.innerHTML
}

export function trimSelectionWhitespace(
  doc: PmNode,
  from: number,
  to: number
): { from: number; to: number } {
  const text = doc.textBetween(from, to)
  const leadingWs = text.length - text.trimStart().length
  const trailingWs = text.length - text.trimEnd().length
  const newFrom = from + leadingWs
  const newTo = to - trailingWs
  // If trimming collapses the range entirely, return original
  if (newFrom >= newTo) return { from, to }
  return { from: newFrom, to: newTo }
}
